import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import Button from '../../shared/buttons/Button';
import PasswordInput from '../../shared/input/PasswordInput';

const ChangePasswordForm = ({ loading, handleChangeMyInfo }) => {
  const methods = useForm();
  return (
    <FormProvider {...methods}>
      <form
        id="password-form"
        noValidate
        className="modal-form"
        onSubmit={methods.handleSubmit((data) => {
          handleChangeMyInfo(data);
          methods.reset();
        })}
      >
        <PasswordInput name="password" disabled={loading} placeholder="Введіть пароль" label="Поточний пароль" />
        <PasswordInput name="newPassword" disabled={loading} placeholder="Введіть пароль" label="Новий пароль" />
        <div className="w-full flex justify-end">
          <Button
            className={'mt-2'}
            type={'submit'}
            disabled={loading}
            variant={'primary'}
            formId={'password-form'}
            children={'Зберегти'}
          />
        </div>
      </form>
    </FormProvider>
  );
};

export default ChangePasswordForm;
